import AuthRouter from "@/context/security/router/AuthRouter";
const lazyPage = (): Promise<any> => import("@/context/security/pages/AuthPage.vue");
const lazyLogin = (): Promise<any> => import("@/context/security/component/LoginForm.vue");
export default [
  {
    path: AuthRouter.BASE_PATH,
    component: lazyPage,
    label: "Autoryzacja",
    icon: "mdi-view-dashboard",
    visible: false,
    children: [
      {
        path: "login",
        name: AuthRouter.LOGIN_ROUTE_NAME,
        label: "Tworzenie",
        url: `${AuthRouter.BASE_PATH}/login`,
        icon: "mdi-view-dashboard",
        visible: false,
        component: lazyLogin
      }
    ]
  }
];
